import { Chip } from '@mui/material';

export const trainerMOUTableHeader = [
  { field: 'sl_no', headerName: 'Sl No.', width: 120 },
  { field: 'trainer_alphanum_id', headerName: 'Trainer ID', width: 150, sortable: true },
  { field: 'full_name', headerName: 'Trainer Name', width: 250, sortable: true, toolTipGetter: true },
  { field: 'mob_no', headerName: 'Contact No.', width: 150 },

  { field: 'mou_accepted_on', headerName: 'Date of Acceptance', width: 210, sortable: true },
  { field: 'mou_amount', headerName: 'Amount', width: 150, sortable: true },

  { field: 'mou_transaction_date', headerName: 'Transaction Date', width: 180, sortable: true },
  { field: 'mou_payment_mode', headerName: 'Payment Mode', width: 150 },
  {
    field: 'mou_screenshot',
    headerName: 'Screenshot',
    width: 140,
    type: 'action',
    actionType: 'view',
    actionKey: 'View ScrnShot',
  },

  { field: 'mou_remarks', headerName: 'Remarks', width: 200, toolTipGetter: true },
  { field: 'collected_by_name', headerName: 'Collected By', width: 250, toolTipGetter: true },
  { field: 'mou_details_updated_on', headerName: 'Added On', width: 160, sortable: true },

  {
    field: 'verification_status',
    headerName: 'Verification',
    width: 140,
    renderCell: ({ value }) =>
      Boolean(value) ? (
        <Chip label="Verified" color="success" variant="outlined" />
      ) : (
        <Chip label="Not Verified" color="error" variant="outlined" />
      ),
  },
  { field: 'refund_status', headerName: 'Refund', width: 190, toolTipGetter: true },
  { field: 'action', headerName: 'Action', width: 120, type: 'action', actionType: 'edit', actionKey: 'Update' },
];
